import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { CookieBanner } from './components/CookieConsent';
import Generate from './components/Generate';
import Landing from './components/Landing';
import MyStories from './components/MyStories';
import Header from './components/Nav';
import LegalPage from './components/LegalPage';
import ImprintPage from './components/ImprintPage';
import FAQPage from './components/faqpage';
import { HelmetProvider } from 'react-helmet-async';
import ProductPage from './components/ProductPage';
import CreativityLanding from './components/blog-sites/CreativityLanding';
import SleepLanding from './components/blog-sites/SleepLanding';
import BlogLayout from './components/blog-sites/BlogLayout';
import EasterLanding from './components/blog-sites/EasterLanding';
import TonieLanding from './components/blog-sites/TonieLanding';

// Separate component for the app content to use hooks that require Router context
function AppContent() {
  const location = useLocation();
  const isLandingPage = location.pathname === '/';
  const isBlogPage = location.pathname.startsWith('/blog');

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#EDD1BA' }}>
      {!isLandingPage && !isBlogPage && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/blog" element={<BlogLayout />}>
            <Route path="kreativitaet" element={<CreativityLanding />} />
            <Route path="einschlafgeschichten" element={<SleepLanding />} />
            <Route path="ostergeschichten" element={<EasterLanding />} />
            <Route path="kreativ-tonie-geschichten" element={<TonieLanding />} />
          </Route>
          <Route path="/product" element={<ProductPage />} />
          <Route path="/erstellen" element={<Generate />} />
          <Route path="/meine-geschichten" element={<MyStories />} />
          <Route path="/agb" element={<LegalPage />} />
          <Route path="/impressum" element={<ImprintPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

// Simple inline auth wrapper component
function RequireAuth({ children }) {
  const { user, loading, emailLinkError } = useAuth();
  
  // Add this check before any redirects
  const isEmailSignInAttempt = window.location.href.includes('?email=');
  
  // Show loading state while checking auth or processing email sign-in
  if (loading || isEmailSignInAttempt) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-xl"></div>
      </div>
    );
  }
  
  if (emailLinkError) {
    return <Navigate to="/" state={{ emailLinkError }} />;
  }
  
  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Add this new component in App.js
function RedirectIfAuthenticated({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-xl"></div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/erstellen" replace />;
  }

  return children;
}

export default App;
